module.exports = __webpack_public_path__ + "img/icon-marker-accent-3.eb699f6b.svg";